"use client";

import { EOChatLogo } from "@/components/icons/eo-chat";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import Link from "next/link";
import { useSearchParams } from "next/navigation";

export default function LoginPage() {
  const searchParams = useSearchParams();
  const error = searchParams.get("error");
  const next = searchParams.get("next");
  const authorizeHref = next
    ? `/api/auth/authorize?next=${encodeURIComponent(next)}`
    : "/api/auth/authorize";

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center space-y-2">
          <div className="flex justify-center">
            <EOChatLogo width={120} height={48} />
          </div>
          <CardTitle>Sign in</CardTitle>
          <CardDescription>
            Use your organisation&apos;s identity provider to access the EO Agent Chat.
            Click the button below to sign in.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {error && (
            <p className="text-sm text-destructive text-center" role="alert">
              {error === "config" && "Login is not configured. Contact support."}
              {error === "invalid_state" && "Invalid or expired login request. Please try again."}
              {error === "missing_code_or_state" && "Login was cancelled or incomplete."}
              {error === "discovery_failed" && "Could not reach the identity provider."}
              {error === "token_exchange_failed" && "Login failed. Please try again."}
              {error === "no_tokens" && "No session was returned. Please try again."}
              {!["config", "invalid_state", "missing_code_or_state", "discovery_failed", "token_exchange_failed", "no_tokens"].includes(error) && error}
            </p>
          )}
          <Button asChild className="w-full" size="lg" variant="brand">
            <Link href={authorizeHref}>Log in</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
